<script>
export default {
    mounted() {
        var logo = greensock.timeline();

        logo.set(this.$refs.houseMask, { x: '-108%' })
            .set(this.$refs.treeLeft, { y: '108%' })
            .set(this.$refs.treeRight, { y: '108%' })
            .set(this.$refs.logoType, { opacity: 0 })
            .to(this.$refs.houseMask, {
                x: '0',
                duration: 3.2,
                delay: 0.32,
                ease: 'power2.inOut'
            })
            .to(
                this.$refs.treeLeft,
                {
                    y: '0',
                    duration: 2.2,
                    ease: 'power2.inOut'
                },
                '>-2.8'
            )
            .to(
                this.$refs.treeRight,
                {
                    y: '0',
                    duration: 2.2,
                    ease: 'power2.inOut'
                },
                '>-1.8'
            )
            .to(
                this.$refs.logoType,
                {
                    opacity: 1,
                    duration: 0.5,
                    ease: 'power1.in',
                    onComplete: this.animated
                },
                '>-0.16'
            );
    },

    methods: {
        animated() {
            this.$emit('animated', true);
        }
    }
};
</script>
